window.stComponentLoader = null;

function loadSpendTrackerComponentInstance() {
    window.stComponentLoader = window.loadComponentInstance('SpendTracker', {}, {
        mountNode: '#SpendTracker'
    })
        .then((vm) => {
            window.spendTracker = vm.$children[0];
            window.stComponentLoader = null;
        });
}

window.updateSpendTracker = function(objData) {
    // If Spendtracker has not been added to the DOM and a component instance is not
    // already loading, load the SpendTracker component instance
    if ($('#SpendTracker_Outer').length === 0 && window.stComponentLoader === null) {
        loadSpendTrackerComponentInstance();
    }

    window.stComponentLoader.then(() => {
        window.spendTracker.SR = objData.SR;
        window.spendTracker.Total = objData.Total;
        window.spendTracker.Itemized = objData.Itemized;
        //window.spendTracker.Expenses - objData.Expenses
    });
};